const EXPLICIT_CHOICE_PREFIX_REGEX = /^\s*(?:\([A-Fa-f]\)\s+|[A-Fa-f][.)\]:：、．]\s*)/;

export function hasExplicitChoicePrefix(value: string): boolean {
  return EXPLICIT_CHOICE_PREFIX_REGEX.test(value);
}

export function withChoiceLabel(
  value: string,
  index: number,
  labels: readonly string[] = ['A', 'B', 'C', 'D', 'E', 'F'],
): string {
  const trimmed = value.trim();
  if (hasExplicitChoicePrefix(trimmed)) {
    return trimmed;
  }
  const label = labels[index] ?? `${index + 1}`;
  return `${label}. ${trimmed}`;
}
